import { PsObject } from "@/object/core/PsObject";

export default class coinHolder extends PsObject<coinHolder> {
    


    id : string = '';
    coin : string = '';
    userId : string = ''; 
    addedDateStr : string = '';


    init(
        id : string,
        coin : string,
        userId : string,
        addedDateStr : string,

    ) {
        this.id = id;
        this.coin = coin;
        this.userId = userId;
        this.addedDateStr = addedDateStr;
        
        
        return this;

    }
    toMap(object: coinHolder): any {
        const map = {};
         
        map['id'] = object.id;
        map['coin'] = object.coin;
        map['user_id'] = object.userId;
        map['added_date_str'] = object.addedDateStr;
        return map;
    }
    getPrimaryKey(): string {
        return this.id;
    }
    toMapList(objectList: coinHolder[]): any[] {
        const mapList: any[] = [];
        for (let i = 0; i < objectList.length; i++) {
            if (objectList[i] != null) {
                mapList.push(this.toMap(objectList[i]));
            }
        }

        return mapList;
    }

    fromMap(obj: any) {
        return new coinHolder().init(
            obj.id,
            obj.coin,
            obj.user_id,
            obj.added_date_str,
            
        );
    }

    fromMapList(objList: any[]): coinHolder[] {
        const cartHistoryList: coinHolder[] = [];
        for (const obj in objList) {
            if (obj != null) {
                cartHistoryList.push(this.fromMap(obj));
            }
        }

        return cartHistoryList;
    }
}
